import { render, staticRenderFns } from "./print-template.vue?vue&type=template&id=5056ba36&scoped=true&"
import script from "./print-template.vue?vue&type=script&lang=ts&"
export * from "./print-template.vue?vue&type=script&lang=ts&"
import style0 from "./print-template.vue?vue&type=style&index=0&id=5056ba36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056ba36",
  null
  
)

export default component.exports